<template>
  <div
    v-if="user"
    class="col-md-2 hidden-xs hidden-sm">
    <div class="theme-account-sidebar">
      <div class="theme-account-avatar">
        <p class="theme-account-avatar-name">Bem vindo,</p>
        <p>{{ user.first_name }}</p>
      </div>
      <nav class="theme-account-nav">
        <ul class="theme-account-nav-list">
          <li>
            <router-link :to="{name:'myaccount'}">
              <i class="fa fa-cog"></i>Minha Conta
            </router-link>
          </li>
          <li>
            <router-link :to="{name:'orders'}" exact>
              <i class="fa fa-history"></i>Meus Pedidos
            </router-link>
          </li>
          <li v-if="user.isAdmin">
            <router-link :to="{name:'orders', query:{all_orders: true}}" exact>
              <i class="fa fa-history"></i>Todos os Pedidos
            </router-link>
          </li>
          <li>
            <router-link :to="{name:'company'}">
              <i class="fa fa-building"></i>Empresa
            </router-link>
          </li>
          <li>
            <router-link :to="{name:'cards'}">
              <i class="fa fa-credit-card"></i>Cartões
            </router-link>
          </li>
          <li v-if="user.isAgent || user.isAdmin">
            <router-link :to="{name:'travelers'}">
              <i class="fa fa-user-circle-o"></i>Titulares
            </router-link>
          </li>
          <li>
            <router-link :to="{name:'travelersdependent', query:{all_dependents: false}}" exact>
              <i class="fa fa-user-circle-o"></i>Meus Dependentes
            </router-link>
          </li>
          <li v-if="user.isAgent || user.isAdmin">
            <router-link :to="{name:'travelersdependent', query:{all_dependents: true}}" exact>
              <i class="fa fa-user-circle-o"></i>Todos os Dependentes
            </router-link>
          </li>
          <!-- <li>
            <router-link :to="{name:'reports'}">
              <i class="fa fa-area-chart"></i>Relatórios
            </router-link>
          </li> -->
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('auth', ['user'])
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/components/template/ScopedMenu';
</style>
